module.exports = __webpack_public_path__ + "img/18.7fe5d287.jpg";